export const BASE_URL = 'forms-templates';

// Mirrors the backend's SHARED_FORM_TEMPLATE_KEYS in form-template-reach.constants.ts (a hand-mirrored
// contract, the house pattern): the two lists must change together.
export const SHARED_FORM_TEMPLATE_KEYS: readonly string[] = [
  'tp_benchmark_intake',
];
